export default {
  data() {
    const confirmationBankSchema = [
      {
        label: 'Bank Name',
        type: 'input',
        key: 'bankName',
      },
      {
        label: 'Reference Number',
        type: 'input',
        key: 'referenceNumber',
      },
    ]
    return {
      confirmationBankSchema,
    }
  },
}
